// Mount the /labs/search island. The SSR shell provides the filter vocabulary in
// the island payload; ids and payload type both come from the shared contract.
import { Islands } from "@brave-new-world/shared";
import { mountIsland } from "../../ui/islands";
import { LabsSearchApp } from "./LabsSearchApp";

export function initLabsSearch(): void {
  // Fallback renders the page with an empty vocabulary rather than not at all.
  mountIsland(Islands.labsSearch, LabsSearchApp, { colors: [], categories: [] });
}
